import { SALE_TYPE } from "../../constant/shared-constants";

export function mapSaleTagValue(tag: any, value: any, t) {
  let label = "";
  switch (tag) {
  case SALE_TYPE.UPTOOFF:
    label = t("upto_off", { value });
    break;
  case SALE_TYPE.FROM:
    label = t("from", { value });
    break;
  case SALE_TYPE.LIMITEDOFFER:
    label = t("Limited Offers");
    break;
  case SALE_TYPE.LIMITEDOFFERUPTO:
    label = t("limited_offer_upto", { value });
    break;
  case SALE_TYPE.DEALUPTO:
    label = t("deal_upto");
    break;
  case SALE_TYPE.SAVE:
    label = t("save", { value });
    break;
  case SALE_TYPE.ENDINGSOON:
    label = t("Ending Soon");
    break;
  default:
    label = t("Sale");
  }
  return label;
}
